<template>
  <section class="pb-16 mb-16" id="partners">
    <v-container fluid id="products" class="mt-2">
      <v-row align="center" justify="center">
        <v-col cols="10">
          <p justify="left">{{ translate('partners_1')}} <span style="color: #61BB46;">sYxpaY</span></p>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" class="mt-2">
            <v-col
              cols="12"
              sm="3"
              class="text-center"
              v-for="(item, i) in items"
              :key="i"
            >
              <v-hover v-slot:default="{ hover }">
                <v-container>
                  <div
                  class="d-md-none d-lg-block d-xl-block d-sm-none"
                    style="position: absolute; transform: translate(25px,-30px); z-index: 1;"
                  >
                    <v-img
                      :src="item.img"
                      max-width="100px"
                      class="d-block ml-auto mr-auto"
                      :class="{ 'zoom-efect': hover }"
                    ></v-img>
                  </div>
                  <div
                  class="d-md-none d-lg-block d-xl-block d-sm-none"
                    style="position: relative; transform: translate(140px,-20px); z-index: 1;"
                  >
                    <v-img max-width="30px" src="@/assets/syxpay/petik.png"></v-img>
                  </div>
                  <v-card
                    class="card px-4 py-4"
                    width="auto"
                    min-height="330px"
                    :elevation="hover ? 10 : 4"
                    :class="{ up: hover }"
                    style="overflow: hidden; position: relative; border-radius: 15px;"
                  >
                  <div class="pt-2 ma-2" style="font-size: 15px;">
                    <p style="font-weight: 500; color: #61BB46; margin-top: 40px; margin-bottom: 5px; text-align: end;">{{ item.title }}</p>
                    <!-- <p style="text-align: justify;">{{ item.text }}</p> -->
                    <p class="text-balance text-justify">{{ item.text }}</p>
                  </div>
                  </v-card>
                </v-container>
              </v-hover>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  props: ['translate'],
  data() {
    return {
      dialog: false,
      videoId: "i8IvvHJssWE",
      rawItems: [
        {
          img: require("@/assets/syxpay/tata.png"),
          key: 'tata',
          partnersKey: 'partners_tata'
        },
        {
          img: require("@/assets/syxpay/hanggar.png"),
          key: 'hanggar',
          partnersKey: 'partners_hanggar'
        },
        {
          img: require("@/assets/syxpay/rianti.png"),
          key: 'rianti',
          partnersKey: 'partners_rianti'
        },
        {
          img: require("@/assets/syxpay/amalia.png"),
          key: 'amalia',
          partnersKey: 'partners_amalia'
        },
      ],
    };
  },
  computed: {
    items() {
      return this.rawItems.map(item => ({
        img: item.img,
        title: this.translate(item.key),
        text: this.translate(item.partnersKey)
      }));
    }
  }
};
</script>
